<script>
import Tawk from 'vue-tawk';
import Vue from 'vue'
export default {
  components: {},
  methods: {
    initTawk() {
      Vue.use(Tawk, {
        tawkSrc: 'https://embed.tawk.to/6436b49231ebfa0fe7f7e506/1gtqr2n1j',
      });
    }
  },
  mounted() {
    this.initTawk();
  },
};
</script>
    
<template>
  <div class="bg-secondary bg-opacity-10 d-flex flex-column" style="min-height: 100vh">
    <slot />
    <div class="text-center pb-4">
      {{ new Date().getFullYear() - 1 }} - {{ new Date().getFullYear() }} © Product-Designer.com
    </div>
  </div>
</template>